export var Org;
(function (Org) {
    Org.RootId = '18f923a7-5a5e-426d-94ae-a55ad1a4b240'; // 企业组织机构id
    /** 类型 */
    let UnitType;
    (function (UnitType) {
        /** 默认值 */
        UnitType[UnitType["Default"] = 0] = "Default";
        /** 未指定 */
        UnitType[UnitType["Unspecified"] = 15] = "Unspecified";
        /** 公司 */
        UnitType[UnitType["Company"] = 1] = "Company";
        /** 组织单元 */
        UnitType[UnitType["OrganizationUnit"] = 2] = "OrganizationUnit";
        /** 用户 */
        UnitType[UnitType["User"] = 4] = "User";
        /** 角色 */
        UnitType[UnitType["Role"] = 8] = "Role";
        /** 编制 */
        UnitType[UnitType["Post"] = 16] = "Post";
        /** 角色组 */
        UnitType[UnitType["RoleGroup"] = 20] = "RoleGroup";
    })(UnitType = Org.UnitType || (Org.UnitType = {}));
    let OrgNodeType;
    (function (OrgNodeType) {
        /** user,org,role */
        OrgNodeType[OrgNodeType["Unit"] = 0] = "Unit";
        /** 系统变量，参与者控件 */
        OrgNodeType[OrgNodeType["Variables"] = 1] = "Variables";
        /** 参与者函数 */
        OrgNodeType[OrgNodeType["Function"] = 2] = "Function";
    })(OrgNodeType = Org.OrgNodeType || (Org.OrgNodeType = {}));
    let UserGenderType;
    (function (UserGenderType) {
        /** 未知 */
        UserGenderType["None"] = "None";
        /** 男 */
        UserGenderType["Male"] = "Male";
        /** 女 */
        UserGenderType["Female"] = "Female";
    })(UserGenderType = Org.UserGenderType || (Org.UserGenderType = {}));
    let UserGender;
    (function (UserGender) {
        /** 未知 */
        UserGender["None"] = "\u672A\u77E5";
        /** 男 */
        UserGender["Male"] = "\u7537";
        /** 女 */
        UserGender["Female"] = "\u5973";
    })(UserGender = Org.UserGender || (Org.UserGender = {}));
    let WeChartOrgType;
    (function (WeChartOrgType) {
        WeChartOrgType["Department"] = "departmentName";
        WeChartOrgType["User"] = "userName";
        WeChartOrgType["UserAvatar"] = "userAvatar";
    })(WeChartOrgType = Org.WeChartOrgType || (Org.WeChartOrgType = {}));
    /** 人员部门类型枚举 */
    let OrgScopeType;
    (function (OrgScopeType) {
        /** 未指定 */
        OrgScopeType[OrgScopeType["Unspecified"] = -1] = "Unspecified";
        /** 内部组织 */
        OrgScopeType[OrgScopeType["INNER"] = 1] = "INNER";
        /** 外部组织 */
        OrgScopeType[OrgScopeType["EXTERNAL"] = 2] = "EXTERNAL";
        /** 全部 */
        OrgScopeType[OrgScopeType["ALL"] = 3] = "ALL";
    })(OrgScopeType = Org.OrgScopeType || (Org.OrgScopeType = {}));
})(Org || (Org = {}));
